import { z } from 'zod';

export const SOutletListServiceRequest = z.object({
  min_price: z.number().optional(),
  max_price: z.number().optional(),
  location: z.array(z.string()).optional(),
  product_type: z.array(z.string()).optional(),
  search: z.string().optional().nullable(),
  longitude: z.number().optional(),
  latitude: z.number().optional(),
  order_by: z.string().optional(),
});

export type TOutletListServiceRequest = z.infer<
  typeof SOutletListServiceRequest
>;

export const SProductListServiceRequest = z.object({
  min_price: z.number().optional(),
  max_price: z.number().optional(),
  location: z.array(z.string()).optional(),
  product_type: z.array(z.string()).optional(),
  search: z.string().optional(),
  longitude: z.number().optional(),
  latitude: z.number().optional(),
  order_by: z.string().optional(),
  offset: z.number().optional(),
  size: z.number().optional(),
  is_not_ethical: z.boolean().optional(),
});

export type TProductListServiceRequest = z.infer<
  typeof SProductListServiceRequest
>;

export const SConsultListServiceRequest = z.object({
  min_price: z.number().optional().nullable(),
  max_price: z.number().optional().nullable(),
  location: z.array(z.string()).optional(),
  product_type: z.array(z.string()).optional(),
  search: z.string().nullable().optional(),
  longitude: z.number().optional(),
  latitude: z.number().optional(),
  order_by: z.string().optional(),
  offset: z.number().optional(),
  size: z.number().optional(),
  service_method: z.array(z.string()).optional().nullable(),
  payment_method: z.array(z.string()).optional().nullable(),
  min_date: z.string().optional().nullable(),
  max_date: z.string().optional().nullable(),
});

export type TConsultListServiceRequest = z.infer<
  typeof SConsultListServiceRequest
>;
